export { startLighthouseObserver, getLighthouseMetrics } from './utils/lighthouse-metrics';
export { getCacheHitRatio } from './utils/cache-hit-ratio';
